module.exports = __webpack_public_path__ + "static/img/通用_bottom.1bc557ce.png";